import request from "./request";
import { isMobileClient } from "@/utils/help";

export const getMeetingConfig = (id) =>
  request({
    url: `/conference/user/home/config?id=${id}`,
  });

// 通过主机名获取配置
export const getMeetingConfigByUrl = (url) =>
  request({
    url: `/conference/user/home/configByUrl?url=${url}`,
  });

export const getTabList = (id) =>
  // showStatusFlag 查询对应设备的菜单
  request({
    url: `/conference/user/home/subjectList?platformId=${id}&showStatusFlag=${isMobileClient()}`,
  });

export const getSubjectDetail = (params) =>
  request({
    url: "/conference/user/home/subject/more",
    params,
  });

// 根据大会id获取大会订单列表
export const getOrderByMeetingId = (id) =>
  request({
    url: `/conference/user/home/apply/orderListByMeetingId?meetingId=${id}`,
  });

// 获取会议列表
export const getActiveListByMeetingId = (id) =>
  request({
    url: `/conference/user/home/apply/applyList?meetingId=${id}`,
  });

// 获取报名表单模板
export const getTemplateContentById = (id) =>
  request({
    url: `/conference/user/template/getByIdNoInfo?id=${id}`,
  });

// 提交报名信息 - 单个
export const submitOrder = (data) =>
  request({
    url: "/conference/user/home/apply/submitOrder",
    method: "post",
    data,
  });

// 提交报名信息 - 多个
export const submitOrderList = (data) =>
  request({
    url: "/conference/user/home/apply/submitOrderList",
    method: "post",
    data,
  });

// 取消报名 - 订单id
export const cancelOrder = (id) =>
  request({
    url: `/conference/user/home/cancelOrder/${id}`,
    method: "post",
  });

// 查看报名状态
export const getApplyStatusByActiveId = (id) =>
  request({
    url: `/conference/user/home/apply/getApplyStatus?id=${id}`,
  });

// 提交发票信息
export const submitInvoiceInfo = (data) =>
  request({
    url: "/conference/user/home/apply/submitInvoiceApply",
    method: "post",
    data,
  });

// 获取会议日程查询列表
export const getScheduleFilterOps = (id) =>
  request({
    url: `/conference/user/home/subject/schedule/getQueryCondition?platformId=${id}`,
  });

// 获取会议讲者列表
export const getSpeakerListGroup = (data) =>
  request({
    url: "/conference/user/home/subject/schedule/getQueryCondition/allPeoPle",
    method: "post",
    data,
  });
// 获取会议日程
export const getScheduleList = (params) =>
  request({
    url: "/conference/user/home/subject/schedule/list",
    params,
  });

// 投稿- 列表
export const getContributeListById = (id) =>
  request({
    url: `/conference/user/home/subject/contribute/list?manageId=${id}`,
  });

// 投稿
export const submitContribute = (data) =>
  request({
    url: "/conference/user/home/subject/contribute/submit",
    method: "post",
    data,
  });

// 唤起微信支付
export const payOrder = (id) =>
  request({
    url: `/conference/user/home/apply/prepay/${id}`,
    method: "post",
  });

// 兑换码接口
export const prepayVoucher = (data) =>
  request({
    url: `/conference/user/home/apply/prepay/voucher`,
    method: "post",
    data,
  });

// 获取大会报名表单提交列表
export const getActiveFormContentListByMeetingId = (id) =>
  request({
    url: `/conference/user/home/apply/listByMeetingId?meetingId=${id}`,
  });

// 提交报名信息 - 单个
export const submitFormContent = (data) =>
  request({
    url: "/conference/user/home/apply/submit",
    method: "post",
    data,
  });

// 提交订单 - 单个
export const submitActivityOrder = (data) =>
  request({
    url: "/conference/user/home/apply/submitSingleOrder",
    method: "post",
    data,
  });

// 发送重置密码邮件
export const sendResetPasswordsApi = (data) =>
  request({
    url: "/user/email/sendResetPasswords",
    method: "post",
    data,
  });

// 根据活动id获取活动详情
export const getActivityDetailById = (id) =>
  request({
    url: `conference/activity/admin/detailByApplyId?applyId=${id}`,
  });
